import { gql } from '@apollo/client'

export const CREATE_PASSWORD = gql`
  mutation SIGNUP($signup: SignupModelInput!) {
    authentication {
      signUp(signup: $signup) {
        success
        mobilePhone
      }
    }
  }
`

export interface CreatePasswordVariables {
  signup: {
    userName: string
    password: string
    invitationGuid: string
  }
}

export interface CreatePasswordResponseData {
  success: boolean
  mobilePhone: string
  error: string
}

export interface CreatePasswordResponse {
  authentication: {
    signUp: CreatePasswordResponseData
  }
}

// NewAccountCreateYourPassword mutations finish

// NewAccountVerifyYourPhoneNumber mutations start

export const CONFIRM_SIGNUP = gql`
  mutation VERIFY_PHONE_CODE($userName: String!, $code: String!) {
    authentication {
      confirmSignup(userName: $userName, code: $code) {
        success
        error
      }
    }
  }
`

export interface ConfirmSignupType {
  success?: boolean
  error?: string | null
}

export interface ConfirmSignupVariables {
  userName: string
  code: string
}

export interface ConfirmSignupResponse {
  authentication: {
    confirmSignup: ConfirmSignupType
  }
}

// NewAccountVerifyYourEmailAddress mutations start

export const START_EMAIL_VERIFICATION = gql`
  mutation StartEmailVerification {
    authentication {
      startEmailVerification
    }
  }
`

export const COMPLETE_EMAIL_VERIFICATION = gql`
  mutation CompleteEmailVerification($code: String!) {
    authentication {
      submitEmailVerificationCode(code: $code) {
        success
        error
      }
    }
  }
`

export interface StartEmailVerificationResponse {
  authentication: {
    startEmailVerification: boolean
  }
}

export interface CompleteEmailVerificationResponse {
  authentication: {
    submitEmailVerificationCode: {
      success?: boolean
      error?: string
    }
  }
}

export interface CompleteEmailVerificationVariables {
  code: string
}

// NewAccountVerifyYourPhone mutations start

export const START_PHONE_VERIFICATION = gql`
  mutation StartPhoneVerification {
    authentication {
      startPhoneVerification
    }
  }
`

export const COMPLETE_PHONE_VERIFICATION = gql`
  mutation CompletePhoneVerification($code: String!) {
    authentication {
      submitPhoneVerificationCode(code: $code) {
        success
        error
      }
    }
  }
`

export interface StartPhoneVerificationResponse {
  authentication: {
    startPhoneVerification: boolean
  }
}

export interface CompletePhoneVerificationResponse {
  authentication: {
    submitPhoneVerificationCode: {
      success?: boolean
      error?: string
    }
  }
}

export interface CompletePhoneVerificationVariables {
  code: string
}

// Resend verification code phone number

export const RESEND_PHONE_VERIFICATION_CODE = gql`
  mutation ResendPhoneVerificationCode($userName: String!) {
    authentication {
      resendConfirmationCode(userName: $userName) {
        success
        mobilePhone
      }
    }
  }
`

export interface ResendPhoneCodeVerificationVariables {
  userName: string
}

export interface ResendPhoneCodeVerificationResponse {
  authentication: {
    resendConfirmationCode: {
      success: boolean
      mobilePhone: string | null
    }
  }
}

export const COMPLETE_VERIFY_ACCOUNT_DETAILS = gql`
  mutation UpdateVerifyAccountDetailsStepToCompleted {
    authentication {
      verifyAccountDetails
    }
  }
`

export interface CompleteVerifyAccountDetailsResponse {
  authentication: {
    verifyAccountDetails: boolean
  }
}
